import { Component, Emit, Ref, Vue } from 'vue-property-decorator'
import ValuableConceptsModalComponent from '@/components/valuable-concepts-modal/valuable-concepts-modal.vue'
import ValuableConceptsModal from '@/components/valuable-concepts-modal/valuable-concepts-modal'
import CustomNotificationsModalComponent from '@/modules/diagnosisModule/views/form/modals/SendNotificationModal.vue'
import { BModal } from 'bootstrap-vue'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { BillingStoreHelper } from '@/modules/billing-module/store/billing-store.helper'
import { MenuItemDef } from '@ag-grid-enterprise/all-modules'
import { billingAppliedBillableConceptService } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { ToastUtils } from '@/shared/util/toast-utils'
import { EnumResponse } from '@/api/services/common.dto'

@Component({
    components: {
        ValuableConceptsModalComponent,
        CustomNotificationsModalComponent
    }
})
export default class BillingGridBottomPanelActions extends Vue {
    @Ref() readonly conceptsModal!: ValuableConceptsModal
    @Ref() readonly customNotificationsModal!: BModal

    @Emit()
    refresh(): void {
        // emits an event
    }

    private static get _detailSelectedRows(): AppliedBillableConceptResponse[] {
        return BillingStoreHelper.detailSelectedRows as AppliedBillableConceptResponse[]
    }
    private static get _detailSelectedRow(): StrictNullable<AppliedBillableConceptResponse> {
        return BillingGridBottomPanelActions._detailSelectedRows.length === 1
            ? BillingGridBottomPanelActions._detailSelectedRows[0]
            : null
    }

    get canShowConceptsModal(): boolean {
        return BillingGridBottomPanelActions._detailSelectedRows.length === 1
    }
    get canRequestAuthorization(): boolean {
        return !!BillingGridBottomPanelActions._detailSelectedRow &&
            BillingGridBottomPanelActions._detailSelectedRow.requiresAuthorization &&
            !BillingGridBottomPanelActions._detailSelectedRow.authorizationRequested
    }

    get laboratoryId(): number {
        return store.state.labId
    }
    get caseId(): number | undefined {
        return BillingGridBottomPanelActions._detailSelectedRow?.caseStudy.id
    }
    get notificationType(): EnumResponse | undefined {
        return BillingGridBottomPanelActions._detailSelectedRow?.customer?.predefinedCustomNotificationForAuthorization?.type
    }

    /// SERVICE CALLS ///

    private async _requestAuthorization(appliedBillableConceptId: number): Promise<void> {
        const response =
            await PromiseUtils.toCallSecure(
                billingAppliedBillableConceptService.requestAuthorization(
                    store.state.labId,
                    appliedBillableConceptId))
        if (response !== null) {
            ToastUtils.showToastSuccess(this.$tc('accounting.concept.authorizationRequested'))
            this.refresh() // emits an event
        }
    }

    /// EVENT HANDLERS ///

    onShowConceptsModal(): void {
        if (BillingGridBottomPanelActions._detailSelectedRow) {
            this.conceptsModal.show({
                isBillingModule: true,
                caseId: BillingGridBottomPanelActions._detailSelectedRow.caseStudy.id,
                accountingId: BillingGridBottomPanelActions._detailSelectedRow.unit?.id,
                entityConcept: {
                    entityId: BillingGridBottomPanelActions._detailSelectedRow.entityId,
                    entityType: BillingGridBottomPanelActions._detailSelectedRow.entityType.code
                }
            })
        }
    }

    async onRequestAuthorization(): Promise<void> {
        if (BillingGridBottomPanelActions._detailSelectedRow) {
            if (BillingGridBottomPanelActions._detailSelectedRow.customer?.predefinedCustomNotificationForAuthorization) {
                this.customNotificationsModal.show()
            } else {
                await this._requestAuthorization(BillingGridBottomPanelActions._detailSelectedRow.id)
            }
        }
    }
    async onCustomNotificationSent(): Promise<void> {
        if (BillingGridBottomPanelActions._detailSelectedRow) {
            await this._requestAuthorization(BillingGridBottomPanelActions._detailSelectedRow.id)
        }
    }

    ///

    getContextMenuItems(): MenuItemDef[] {
        const menuItems: MenuItemDef[] = []
        if (this.canShowConceptsModal) {
            menuItems.push({
                name: this.$tc('accounting.action.concepts'),
                action: this.onShowConceptsModal
            })
        }
        if (this.canRequestAuthorization) {
            menuItems.push({
                name: this.$tc('accounting.action.requestAuthorization'),
                action: this.onRequestAuthorization
            })
        }
        return menuItems
    }
}
